import * as THREE from 'three'
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader'
import { DRACOLoader } from 'three/examples/jsm/loaders/DRACOLoader'
import EventEmitter from "./eventEmitter";

export default class Resources extends EventEmitter {

    constructor(sources) {

        super()


        // OPTIONS
        this.sources = sources

        // SETUP
        this.items = {}
        this.toLoad = this.sources.length
        this.loaded = 0

        this.setLoaders()
        this.startLoading()
    }

    setLoaders() {
        this.loaders = {}
        this.loaders.textureLoader = new THREE.TextureLoader()
        this.loaders.dracoLoader = new DRACOLoader()
        this.loaders.dracoLoader.setDecoderPath('../draco/')
        // this.loaders.dracoLoader.setDecoderPath('./draco')
        this.loaders.gltfLoader = new GLTFLoader()
        this.loaders.gltfLoader.setDRACOLoader(this.loaders.dracoLoader)
        // this.loaders.cubeTextureLoader = new THREE.CubeTextureLoader()
    }

    startLoading() {

        // loop sources
        for (const source of this.sources) {


            if (source.type === 'gltfModel') {

                this.loaders.gltfLoader.load(
                    source.path + "",
                    (file) => {
                        this.sourceLoaded(source, file)
                        // console.log('GLB', file);

                    }

                )
            }

            else if (source.type === 'texture') {


                this.loaders.textureLoader.load(
                    source.path,
                    (file) => {
                        this.sourceLoaded(source, file)
                    }
                )

            }

            // else if (source.type === 'cubeTexture') {


            //     this.loaders.cubeTextureLoader.load(
            //         source.path,
            //         (file) => {
            //             // console.log('CUBETEXTURE', file);
            //             this.sourceLoaded(source, file)
            //         }
            //     )

            // }

        }

    }

    sourceLoaded(source, file) {

        // console.log('LOAD');
        this.items[source.name] = file

        this.loaded++

        if (this.loaded === this.toLoad) {
            // console.log('FINISH');

            // trigger to World
            this.trigger('ready')
        }

    }
}